import { Routes } from '@angular/router';
import { AddInComponent } from './pages/add-in/add-in.component';
import { PrinterComponent } from './pages/printer/printer.component';
import { WebCaptureComponent } from './pages/web-capture/web-capture.component';
import { GoogleAddonComponent } from './pages/google-addon/google-addon.component';
import { OpenBatchComponent } from './pages/web-capture/open-batch/open-batch.component';
import { WebCaptureUploadComponent } from './pages/web-capture/web-capture-upload/web-capture-upload.component';
import { WebCaptureBatchingComponent } from './pages/web-capture/web-capture-batching/web-capture-batching.component';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { WebCaptureBatchCreationComponent } from './pages/web-capture/web-capture-batch-creation/web-capture-batch-creation.component';
import { UnauthorizedComponent } from './pages/web-capture/unauthorized/unauthorized.component';
import { DocumentUploadComponent } from './pages/web-capture/document-upload/document-upload.component';
import { TranscriptProcessingComponent } from './pages/transcript-processing/transcript-processing.component';
import { TranscriptQueueComponent } from './pages/transcript-processing/transcript-queue/transcript-queue.component';
import { TranscriptDataComponent } from './pages/transcript-processing/transcript-data/transcript-data.component';
import { IntelligenceComponent } from './pages/intelligence/intelligence.component';
import { IntelligenceDashboardComponent } from './pages/intelligence/intelligence-dashboard/intelligence-dashboard.component';
import { TranscriptUnlockGuard } from './guards/transcripts.guard';
import { SignedOutComponent } from './pages/auth/signed-out/signed-out.component';
import { ItpManagementComponent } from './pages/intelligence/itp-management/itp-management.component';
import { PrinterAuthorizeComponent } from './pages/web-capture/printer-authorize/printer-authorize.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/webcapture',
    pathMatch: 'full'
  },
  {
    path: 'googleaddon',
    component: GoogleAddonComponent,
    data: { title: 'Send to Etrieve' }
  },
  {
    path: 'outlookaddin',
    component: AddInComponent,
    data: { title: 'Send to Etrieve' }
  },
  {
    path: 'printer',
    component: PrinterComponent,
    data: { title: 'Softdocs Virtual Printer' }
  },
  // Legacy redirects for transcript URLs.
  {
    path: 'webcapture/transcripts',
    redirectTo: '/transcripts',
    pathMatch: 'full'
  },
  {
    path: 'webcapture/transcripts/transcript-upload',
    redirectTo: '/transcripts/transcript-upload',
    pathMatch: 'full'
  },
  {
    path: 'webcapture',
    component: WebCaptureComponent,
    data: { title: 'Softdocs Web Capture' },
    canDeactivate: [CanDeactivateGuard],
    children: [
      {
        path: '',
        component: WebCaptureUploadComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Web Capture | Document Upload' }
      },
      {
        path: 'documentupload',
        component: DocumentUploadComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Web Capture | Document Upload' }
      },
      {
        path: 'batches/new',
        component: WebCaptureBatchCreationComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Web Capture | Batch Creation' }
      },
      {
        path: 'batches',
        component: WebCaptureBatchingComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Web Capture | Batches' }
      },
      {
        path: 'batches/:batchId',
        component: OpenBatchComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Web Capture | Open Batch' }
      },
      {
        path: 'printer/authorize',
        component: PrinterAuthorizeComponent,
        data: { title: 'Softdocs Printer Authorization' }
      }
    ]
  },
  {
    path: 'transcripts',
    component: TranscriptProcessingComponent,
    data: { title: 'Softdocs Intelligent Transcript Processing' },
    children: [
      {
        path: '',
        component: TranscriptQueueComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Transcript Processing' }
      },
      {
        path: 'transcript-upload',
        component: TranscriptDataComponent,
        canDeactivate: [CanDeactivateGuard, TranscriptUnlockGuard],
        data: { title: 'Transcript Processing' }
      }
    ]
  },
  {
    path: 'intelligence',
    component: IntelligenceComponent,
    data: { title: 'Softdocs Intelligence' },
    canDeactivate: [CanDeactivateGuard],
    children: [
      {
        path: 'idpmanagement',
        component: IntelligenceDashboardComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Intelligence | IDP Management' }
      },
      {
        path: 'itpmanagement',
        component: ItpManagementComponent,
        canDeactivate: [CanDeactivateGuard],
        data: { title: 'Intelligence | ITP Management' }
      }
    ]
  },
  {
    path: 'signedout',
    component: SignedOutComponent,
    data: { title: 'Signed Out' }
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    data: { title: 'Unauthorized' }
  }
];
